export const INTEGRATION_REQUEST_ADMIN_STORAGE_KEY_PREFIX = "si:management-integration:request-admin-";
export const DYNAMICS_ENRICHMENT_INTEREST_STORAGE_KEY = "si:manage-integrations:dynamics-enrichment-interest-sent";
